import { render, staticRenderFns } from "./SidRangeSlider.vue?vue&type=template&id=8c70ceb2"
import script from "./SidRangeSlider.vue?vue&type=script&lang=js"
export * from "./SidRangeSlider.vue?vue&type=script&lang=js"
import style0 from "./SidRangeSlider.vue?vue&type=style&index=0&id=8c70ceb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports